import styled from "styled-components";
import ButtonGradient from "./ButtonGradient";
import { ReactNode } from "react";

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.CONSTANTS.XW * 2}px;
  margin-top: ${({ theme }) => theme.CONSTANTS.XH * 3}px;
  width: 84%;

  button {
    flex: 1;
  }

  @media (min-width: 1025px) {
    width: 30%;
  }
`;

interface ButtonGroupProps {
  onBack: () => void;
  onNext: () => void;
  backLabel?: ReactNode;
  nextLabel?: ReactNode;
}

const ButtonGroup = ({
  onBack,
  onNext,
  backLabel = "< Voltar",
  nextLabel = "Próximo >",
}: ButtonGroupProps) => {
  return (
    <Wrapper>
      <ButtonGradient onClick={onBack}>{backLabel}</ButtonGradient>
      <ButtonGradient onClick={onNext}>{nextLabel}</ButtonGradient>
    </Wrapper>
  );
};

export default ButtonGroup;
